var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiveLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 670.04 94.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:1.04px;}.cls-3{fill:#fff;}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 499.02,
    y1: 0.82,
    x2: 499.02,
    y2: 45.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3ac2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b498c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 499.02,
    y1: 0.94,
    x2: 499.02,
    y2: 45.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 170.95,
    y1: 0.94,
    x2: 170.95,
    y2: 45.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 5.67,
    y1: 0.94,
    x2: 5.67,
    y2: 45.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -2132.09,
    y1: 417.7,
    x2: -2132.09,
    y2: 589.83,
    gradientTransform: "translate(-412.28 -2131.57) rotate(-90)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "StartUp_NewHome",
    "data-name": "StartUp NewHome"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "664.45 86.49 663.41 86.49 663.41 1.04 334.63 1.04 334.63 85.6 333.59 85.6 333.59 0 664.45 0 664.45 86.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 663.93,
    y1: 68.07,
    x2: 663.93,
    y2: 86.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 334.11,
    y1: 85.6,
    x2: 334.11,
    y2: 68.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M339.81,89.32a5.67,5.67,0,1,1-5.67-5.67A5.67,5.67,0,0,1,339.81,89.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 498.5,
    y: 0.81,
    width: 1.04,
    height: 85.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 499.02,
    y1: 86.49,
    x2: 499.02,
    y2: 68.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M504.69,89.32A5.67,5.67,0,1,1,499,83.65,5.67,5.67,0,0,1,504.69,89.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M670,89.32a5.67,5.67,0,1,1-5.67-5.67A5.67,5.67,0,0,1,670,89.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 170.43,
    y: 0.81,
    width: 1.04,
    height: 85.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 170.95,
    y1: 86.49,
    x2: 170.95,
    y2: 68.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176.62,89.32A5.67,5.67,0,1,1,171,83.65,5.67,5.67,0,0,1,176.62,89.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 5.15,
    y: 0.81,
    width: 1.04,
    height: 85.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.67,
    y1: 86.49,
    x2: 5.67,
    y2: 68.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.34,89.32a5.67,5.67,0,1,1-5.67-5.67A5.67,5.67,0,0,1,11.34,89.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 4.91,
    width: 328.68,
    height: 1.04
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiveLines);
export default __webpack_public_path__ + "static/media/fiveLines.e773b5ecacbbf6e749f0f95287f09aee.svg";
export { ForwardRef as ReactComponent };